//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    selectorData: {
      type: Array,
      required: true,
    },
    selectedValue: {
      type: null,
      required: false,
    },
    isKey: {
      type: Number,
      require: true,
    },
    flag: {
      type: Boolean,
      require: false,
    },
    itemText: {
      type: String,
      required: true,
    },
    currencyClass: {
      type: Boolean,
      required: false,
    },
    isLabel: {
      type: String,
      required: false,
    },
  },
}
